import { Progress, ProgressIndicator } from '@radix-ui/react-progress'

interface ProgressBarProps {
  value: number
  label?: string
  currentStepNumber?: number
  totalSteps?: number
  showSteps?: boolean
}

/**
 * Progress bar with label and percentage or step-based text.
 */
export function ProgressBar({
  value,
  label,
  currentStepNumber,
  totalSteps,
  showSteps = false,
}: ProgressBarProps) {
  const isStepMode = showSteps && currentStepNumber && totalSteps
  const displayLabel = label || 'Progress'

  return (
    <div className='strata:flex strata:flex-col strata:gap-2 strata:p-4 strata:border strata:border-gray-200 strata:rounded-sm'>
      <div className='strata:flex strata:items-center strata:flex strata:items-center strata:justify-between'>
        <span className='strata:text-title-xs strata:font-bold'>{displayLabel}</span>
        <div className='strata:text-body-xs'>
          {isStepMode ? (
            <span>
              <span className='strata:font-bold'>{currentStepNumber}</span>
              {`/${totalSteps}`}
            </span>
          ) : (
            <>
              <span className='strata:font-bold'>{`${value}%`}</span> <span>complete</span>
            </>
          )}
        </div>
      </div>
      <div className=''>
        <Progress
          value={value}
          className='strata:relative strata:h-3 strata:w-full strata:overflow-hidden strata:rounded strata:bg-gray-200'
          style={{ borderRadius: '100px' }}
        >
          <ProgressIndicator
            className='strata:h-full strata:transition-[width] strata:duration-300'
            style={{
              width: `${value}%`,
              background: 'linear-gradient(140.56deg, #EEF4FC 18.09%, #6B5BEC 60.89%)',
              borderRadius: '100px',
            }}
          />
        </Progress>
      </div>
    </div>
  )
}
